import './styles.scss';

import React, { useCallback, useMemo } from 'react';
import SimpleTable, { SimpleTableProps } from '@/components/SimpleTable';

import TripsTableHeader from '@/features/AirlineTrips/components/TripsTable/TripsTableHeader';
import TripsTableRow from '@/features/AirlineTrips/components/TripsTable/TripsTableRow';

type AirlineTripsTableProps = Omit<SimpleTableProps, 'row' | 'columns' | 'rowHeight'>;
const AirlineTripsTable = ({ rows, ...props }: AirlineTripsTableProps) => {
  const Header = useMemo(() => <TripsTableHeader rows={rows} />, [rows]);
  const Row = useCallback((props) => <TripsTableRow {...props} />, []);
  return <SimpleTable className="AirlineTripsTable" rows={rows} columns={Header} row={Row} {...props} />;
};

export default React.memo(AirlineTripsTable);
